import { useState } from 'react'
import { useParams, useHistory } from "react-router-dom";

const PasswordReset = (props) => {
   const [Password, setPassword] = useState('');
   const [ReapeatPassword, setReapeatPassword] = useState('');
   const [Message, setMessage] = useState('');
   const [PasswordChanged, setPasswordChanged] = useState(false);
   const { tkn } = useParams();
   const history = useHistory();

   const ChangePassword = () => {
      const dataForm = new FormData();
      dataForm.append('token', tkn);
      dataForm.append('newPassword', Password);

      if (Password === ReapeatPassword) {
         fetch('Reset hasła krok 2 - https://ddp.systems/api/public/reset-password/step-2', {
            mode: 'no-cors',
            method: 'POST',
            body: dataForm,
         })
            .then(data => {
               if (data.status === 200) {
                  return data.json();
               }
               else if (data.status === 401) {
                  throw Error('Incorrect token');
               }
               else {
                  throw Error('Something went wrong!');
               }
            })
            .then(data => {
               setMessage(data.message);
               setPasswordChanged(true);
            })
            .catch(error => {
               setMessage(error.message);
               // console.log(error.message)
            })

      } else {
         setMessage('Password are not the same')
      }

   }

   return (
      <div className='PasswordReset'>
         {
            PasswordChanged ?
               (
                  <div
                     style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '370px',
                        margin: 'auto',
                        backgroundColor: 'white',
                        padding: '1rem',
                        borderRadius: '5px'
                     }}
                  >
                     <p
                        style={{
                           textAlign: 'center',
                        }}
                     >{Message}</p>
                     <button
                        style={{
                           color: '#fff',
                           backgroundColor: '#007bff',
                           borderColor: '#007bff',
                           borderRadius: '.25rem',
                           boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                        }}
                        onClick={() => { history.push('/') }}
                     >Go to main page</button>
                  </div>
               )
               :
               (<div
                  style={{
                     display: 'flex',
                     flexDirection: 'column',
                     width: '370px',
                     margin: 'auto',
                     backgroundColor: 'white',
                     padding: '1rem',
                     borderRadius: '5px'
                  }}
               >
                  <p
                     style={{
                        textAlign: 'center',
                     }}
                  >{Message}</p>

                  <input type='password' name='password' placeholder='Password'
                     style={{
                        height: 'calc(1.5em + .75rem + 2px)',
                        padding: '.375rem .75rem',
                        // marginTop: '2.5rem',
                        marginBottom: '1rem',
                        borderRadius: '.25rem',
                        border: '1px solid #ced4da',
                        boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                     }}
                     onChange={(e) => { setPassword(e.target.value) }}
                  />
                  <input type='password' name='ReapeatPassword' placeholder='Reapeat Password'
                     style={{
                        height: 'calc(1.5em + .75rem + 2px)',
                        padding: '.375rem .75rem',
                        marginTop: '1rem',
                        marginBottom: '1rem',
                        borderRadius: '.25rem',
                        border: '1px solid #ced4da',
                        boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                     }}
                     onChange={(e) => { setReapeatPassword(e.target.value) }}
                  />
                  <button
                     style={{
                        color: '#fff',
                        backgroundColor: '#007bff',
                        borderColor: '#007bff',
                        borderRadius: '.25rem',
                        boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                     }}
                     onClick={ChangePassword}
                  >Change password</button>
               </div>)
         }

      </div>
   )
}

export default PasswordReset